import { CSSProperties, FC } from "react";
import {
  CheckedInput,
  CheckedLabel,
  CheckedText,
  Checkmark,
  EmojiBox,
} from "./CheckedBtn.styled";
import { Emoji, EmojiStyle } from "emoji-picker-react";

type Props = {
  name: string;
  text: string;
  emoji?: string;
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
};

export const CheckedBtn: FC<Props> = ({
  name,
  text,
  emoji,
  isChecked,
  onChange,
  disabled = false,
  className = "",
  style,
}) => {
  return (
    <CheckedLabel className={`${className}`} style={style}>
      <CheckedInput
        name={name}
        type="checkbox"
        disabled={disabled}
        checked={isChecked}
        onChange={({ target }) => onChange(target.checked)}
      />
      <Checkmark />
      <CheckedText>{text}</CheckedText>

      {emoji && (
        <EmojiBox>
          <Emoji unified={emoji} emojiStyle={EmojiStyle.GOOGLE} size={20} />
        </EmojiBox>
      )}
    </CheckedLabel>
  );
};
